import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { BlockCardReason } from "src/app/ui/models/domains/pbm/Beneficiary/block-card-reason";
import { CardBlockDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/card-block-dto";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { LoadingService } from "src/app/ui/services/loading.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { Toast } from "../../../../toast/toast";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  templateUrl: "./card-block-dialog.component.html",
  styleUrls: ["./card-block-dialog.component.scss"],
})
export class CardBlockDialogComponent implements OnInit {
  blockCardNumberEvent: EventEmitter<Beneficiary | Dependent> = new EventEmitter();

  formGroup: UntypedFormGroup = this.formBuilder.group({
    blockReason: ["", Validators.required],
    includeDependents: [false],
  });

  blockReasonList: BlockCardReason[] = [];

  constructor(
    public dialogRef: MatDialogRef<CardBlockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Beneficiary | Dependent,
    public beneficiaryService: BeneficiaryService,
    public formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private toast: Toast,
  ) {}

  async ngOnInit() {
    this.blockReasonList = await this.beneficiaryService.getBlockReasonList();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  async blockBeneficiaryCard(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const cardBlockDTO = this.buildCardBlockDTO();
      await this.beneficiaryService.blockBeneficiaryCard(cardBlockDTO);
      this.toast.showSuccessToast("Cartão bloqueado com sucesso.");
      this.blockCardNumberEvent.emit(this.data);
      this.closeDialog();
    } catch (err) {
      this.toast.showWarningToast("Erro ao bloquear cartão.");
    } finally {
      loadingRef.closeLoading();
    }
  }

  private buildCardBlockDTO(): CardBlockDTO {
    const beneficiaryKey = this.data.getBeneficiaryKey();
    const blockReason = this.formGroup.get("blockReason").value;
    const includeDependents = this.formGroup.get("includeDependents").value;

    return new CardBlockDTO(beneficiaryKey, blockReason, includeDependents);
  }

  public isBeneficiary(): boolean {
    return this.data instanceof Beneficiary;
  }

  public getName(): string {
    return this.data.getName();
  }

  public getCardNumber(): string {
    return this.data.getCard().getCardNumber();
  }
}
